import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
import { CURRENT_ONBOARDING_ID, ONBOARDINGS_ID } from '../constants';
import { getOnboardingByIdOrFallback } from '../utils';
import useGetOnboardings from './use-get-onboardings';
import useShowOnboarding, { scrollToOnboarding } from './use-show-onboarding';

/** The onboarding the URL selects, for both layouts. A layout without a Current tab opens the newest onboarding for links to it. */
const useSelectedOnboarding = t0 => {
  const $ = _c(37);
  const {
    hasCurrentTab
  } = t0;
  const router = useRouter();
  const {
    isPending,
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetchNextPageError
  } = useGetOnboardings();
  const {
    onboardingId: linkedId,
    onboardingSection,
    setOnboardingId
  } = useShowOnboarding();
  const isCurrentSelected = hasCurrentTab && linkedId === CURRENT_ONBOARDING_ID;
  const onboardingId = linkedId === CURRENT_ONBOARDING_ID ? null : linkedId;
  let onboardings;
  let selectedOnboarding;
  let t1;
  if ($[0] !== data?.pages || $[1] !== isCurrentSelected || $[2] !== onboardingId) {
    onboardings = data?.pages.flatMap(_temp) ?? [];
    selectedOnboarding = getOnboardingByIdOrFallback(onboardings, onboardingId);
    t1 = isCurrentSelected || onboardings.some(onboarding => onboarding.id === onboardingId);
    $[0] = data?.pages;
    $[1] = isCurrentSelected;
    $[2] = onboardingId;
    $[3] = onboardings;
    $[4] = selectedOnboarding;
    $[5] = t1;
  } else {
    onboardings = $[3];
    selectedOnboarding = $[4];
    t1 = $[5];
  }
  const isTargetLoaded = t1;
  const isPagingToTarget = Boolean(onboardingId) && !isTargetLoaded && hasNextPage && !isFetchNextPageError;
  const hasHandledHashRef = useRef(false);
  let t2;
  if ($[6] !== fetchNextPage || $[7] !== isCurrentSelected || $[8] !== isFetchingNextPage || $[9] !== isPagingToTarget || $[10] !== linkedId || $[11] !== selectedOnboarding || $[12] !== setOnboardingId) {
    t2 = () => {
      if (!selectedOnboarding || isFetchingNextPage || isCurrentSelected) {
        return;
      }
      if (isPagingToTarget) {
        fetchNextPage();
      } else {
        if (linkedId !== selectedOnboarding.id) {
          setOnboardingId(selectedOnboarding.id);
        }
      }
    };
    $[6] = fetchNextPage;
    $[7] = isCurrentSelected;
    $[8] = isFetchingNextPage;
    $[9] = isPagingToTarget;
    $[10] = linkedId;
    $[11] = selectedOnboarding;
    $[12] = setOnboardingId;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  const t3 = selectedOnboarding?.id;
  let t4;
  if ($[14] !== isCurrentSelected || $[15] !== isFetchingNextPage || $[16] !== isPagingToTarget || $[17] !== linkedId || $[18] !== t3) {
    t4 = [t3, linkedId, isPagingToTarget, isFetchingNextPage, isCurrentSelected];
    $[14] = isCurrentSelected;
    $[15] = isFetchingNextPage;
    $[16] = isPagingToTarget;
    $[17] = linkedId;
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  useEffect(t2, t4);
  let t5;
  if ($[20] !== isTargetLoaded || $[21] !== onboardingSection || $[22] !== router) {
    t5 = () => {
      if (hasHandledHashRef.current || !isTargetLoaded) {
        return;
      }
      hasHandledHashRef.current = true;
      if (router.asPath.split("#")[1] === ONBOARDINGS_ID) {
        scrollToOnboarding(onboardingSection ?? undefined);
      }
    };
    $[20] = isTargetLoaded;
    $[21] = onboardingSection;
    $[22] = router;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  let t6;
  if ($[24] !== isTargetLoaded) {
    t6 = [isTargetLoaded];
    $[24] = isTargetLoaded;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  useEffect(t5, t6);
  let t7;
  if ($[26] !== error || $[27] !== fetchNextPage || $[28] !== hasNextPage || $[29] !== isCurrentSelected || $[30] !== isFetchingNextPage || $[31] !== isPagingToTarget || $[32] !== isPending || $[33] !== onboardings || $[34] !== selectedOnboarding || $[35] !== setOnboardingId) {
    t7 = {
      isPending,
      error,
      fetchNextPage,
      hasNextPage,
      isFetchingNextPage,
      onboardings,
      selectedOnboarding,
      isCurrentSelected,
      isPagingToTarget,
      setOnboardingId
    };
    $[26] = error;
    $[27] = fetchNextPage;
    $[28] = hasNextPage;
    $[29] = isCurrentSelected;
    $[30] = isFetchingNextPage;
    $[31] = isPagingToTarget;
    $[32] = isPending;
    $[33] = onboardings;
    $[34] = selectedOnboarding;
    $[35] = setOnboardingId;
    $[36] = t7;
  } else {
    t7 = $[36];
  }
  return t7;
};
export default useSelectedOnboarding;
function _temp(page) {
  return page?.data ?? [];
}